// Client-side canvas crop. Takes a data URL/blob URL and a
// react-easy-crop pixel-crop {x,y,width,height} rectangle, returns a
// Blob of the cropped region (JPEG for photos, size-bounded).
export async function getCroppedImageBlob(imageSrc, pixelCrop, { mimeType = "image/jpeg", quality = 0.9, maxSide = 2000 } = {}) {
  const image = await loadImage(imageSrc);
  // Downscale extremely large crops to keep upload size reasonable.
  let outW = pixelCrop.width;
  let outH = pixelCrop.height;
  const longest = Math.max(outW, outH);
  if (longest > maxSide) {
    const scale = maxSide / longest;
    outW = Math.round(outW * scale);
    outH = Math.round(outH * scale);
  }
  const canvas = document.createElement("canvas");
  canvas.width = outW;
  canvas.height = outH;
  const ctx = canvas.getContext("2d");
  ctx.drawImage(
    image,
    pixelCrop.x, pixelCrop.y, pixelCrop.width, pixelCrop.height,
    0, 0, outW, outH
  );
  return new Promise((resolve, reject) => {
    canvas.toBlob((blob) => {
      if (!blob) return reject(new Error("Canvas is empty"));
      resolve(blob);
    }, mimeType, quality);
  });
}

function loadImage(src) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = () => resolve(img);
    img.onerror = (e) => reject(e);
    img.src = src;
  });
}

// Convenience: read a File into a data URL (used to feed the crop modal).
export function readFileAsDataURL(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => resolve(e.target.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}
